export default __webpack_public_path__ + "static/media/ico-alert-info.32c3c573.svg";